<template>
    <v-row class="mt-1">
        <v-col cols="12" sm="6" md="6">
            <v-row 
                v-for="(record, idx) in cdemo_records"
                :key="idx">
                <v-col cols="3" class="font-weight-bold text-capitalize">
                    <span v-if="idx == 0" class="caption d-block">{{ insuranceBasedListings.includes(editData.listing_type) ? '# of Participants' : 'Age Brackets' }}</span>
                    <span v-else class="caption d-block">&nbsp;</span>
                    
                    <span v-if="idx == 0">{{ record.key }}:</span>
                    <span v-else>{{ record.key }}:</span>
                </v-col>
                <v-col cols="4">
                    <v-text-field 
                        v-if="insuranceBasedListings.includes(editData.listing_type)"
                        v-model="record.val.revenue"
                        label="Percentage of Revenue"
                        append-icon="mdi-percent"
                        @change="updateRecords">
                    </v-text-field>
                    <v-text-field 
                        v-if="!insuranceBasedListings.includes(editData.listing_type)"
                        v-model="record.val.age"
                        label="Percentage of Clients"
                        append-icon="mdi-percent"
                        @change="updateRecords">
                    </v-text-field>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4"> 
                    <v-text-field 
                        v-if="insuranceBasedListings.includes(editData.listing_type)"
                        v-model="record.val.participants"
                        label="Percentage of Participants"
                        append-icon="mdi-percent"
                        @change="updateRecords">
                    </v-text-field>
                    <v-text-field 
                        v-if="!insuranceBasedListings.includes(editData.listing_type)"
                        v-model="record.val.assets"
                        label="Percentage of Assets"
                        append-icon="mdi-percent"
                        @change="updateRecords">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row style="border-top: 1px dashed #999" class="mt-3">
                <v-col cols="3" class="font-weight-bold text-capitalize">
                    <span  class="d-block">Totals:</span>
                </v-col>
                <v-col cols="4" class="d-flex justify-space-between font-weight-bold">
                    {{ insuranceBasedListings.includes(editData.listing_type) ? parseFloat(client_revenue_totals.toFixed(2)) : parseFloat(client_age_totals.toFixed(2)) }}<v-icon>mdi-percent</v-icon>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4" class="d-flex justify-space-between font-weight-bold"> 
                    {{ insuranceBasedListings.includes(editData.listing_type) ? parseFloat(client_participant_totals.toFixed(2)) : parseFloat(client_assets_totals.toFixed(2)) }}<v-icon>mdi-percent</v-icon>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>


<script>
    export default {
        name: 'ClientDemographic',
        props: [
            'editData',
            'insuranceBasedListings'
        ],
        data: () => ({
            name: 'ClientDemographic',
            cdemo_records: [],
            client_age_totals: 0,
            client_assets_totals: 0,
            client_revenue_totals: 0,
            client_participant_totals: 0,
        }),

        computed: {
            default_brackets () {
                let define_brackets
                if ( this.insuranceBasedListings.includes(this.editData.listing_type) ) {
                    define_brackets = [
                        {   'key': 'under-50', 
                            'val': { 'revenue': '', 'participants': '' }
                        }, 
                        {   'key': '51-100',
                            'val': { 'revenue': '', 'participants': '' }
                        },
                        {   'key': '101-150',
                            'val': { 'revenue': '', 'participants': '' }
                        },
                        {   'key': '151-200',
                            'val': { 'revenue': '', 'participants': '' }
                        },
                        {   'key': '201-250',
                            'val': { 'revenue': '', 'participants': '' }
                        },
                        {   'key': '251+',
                            'val': { 'revenue': '', 'participants': '' }
                        }
                    ]
                } else {
                    define_brackets = [
                        {   'key': 'under-40', 
                            'val': { 'age': '', 'assets': '' }
                        }, 
                        {   'key': '41-50',
                            'val': { 'age': '', 'assets': '' }
                        },
                        {   'key': '51-60',
                            'val': { 'age': '', 'assets': '' }
                        },
                        {   'key': '61-70',
                            'val': { 'age': '', 'assets': '' }
                        },
                        {   'key': '71-80',
                            'val': { 'age': '', 'assets': '' }
                        },
                        {   'key': '81+',
                            'val': { 'age': '', 'assets': '' }
                        },
                        {   'key': 'Institutions',
                            'val': { 'age': '', 'assets': '' }
                        }
                    ]
                }
                return define_brackets
            }
        },

        mounted () {
            this.createObject()
        },
        watch: {
            editData(val) {
                this.createObject()
            }
        },
        methods: {
            createObject: function () {
                this.cdemo_records=[];
                this.client_age_totals = 0;
                this.client_assets_totals = 0;
                this.client_revenue_totals = 0;
                this.client_participant_totals = 0;

                //console.log('echo:', this.editData.client_demographics)
                if ( this.editData.client_demographics != undefined && Object.keys(this.editData.client_demographics).length !== 0 ) {
                    for ( let [key, val] of Object.entries(this.editData.client_demographics) ) {
                        // console.log(key, val)
                        this.cdemo_records.push({ key, val })
                        this.calcTotals(val);
                    }
                } else {
                    this.cdemo_records = this.default_brackets;
                }
                // console.log(this.cdemo_records)
            },

            updateRecords: function () {
                let updated_values=[], updated_object={};
                this.client_age_totals = 0;
                this.client_assets_totals = 0;
                this.client_revenue_totals = 0;
                this.client_participant_totals = 0;

                for ( let val of this.cdemo_records ) {
                    updated_values.push(val)
                }
                // console.log('updated_values: ',updated_values)

                for (var i = 0; i < updated_values.length; i++) {
                    updated_object[updated_values[i].key] = (updated_values[i].val != '' && typeof updated_values[i].val == 'string') ? parseFloat(updated_values[i].val) : updated_values[i].val;
                    this.calcTotals(updated_values[i].val);
                }
                // console.log('updated_object: ',updated_object)

                this.editData.client_demographics = Object.assign({}, updated_object);
                // console.log('final: ', this.editData.client_demographics)
            },
            
            calcTotals: function ( rec ) {
                for ( let [idx, data] of Object.entries(rec) ) {
                    // console.log(idx, data)
                    if ( this.insuranceBasedListings.includes(this.editData.listing_type) ) {
                        if ( idx == 'revenue' && data != '' ) {
                            this.client_revenue_totals += parseFloat(data);
                        }
                        if ( idx == 'participants' && data != '' ) {
                            this.client_participant_totals += parseFloat(data);
                        }
                    } else {
                        if ( idx == 'age' && data != '' ) {
                            this.client_age_totals += parseFloat(data);
                        }
                        if ( idx == 'assets' && data != '' ) {
                            this.client_assets_totals += parseFloat(data);
                        }
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/ClientDemographic.vue